import { Box } from '@mui/material';
import { Fragment, useState } from 'react';
import Icon from '/@/components/icon';
import NewWeather from '/@/components/weather';
import settings from '/@/core/settings';
import useWindowSize from '/@/utils/hooks/window-size';
import styles from './styles.module.css';

const WeatherComponent = ({ view = 'fieldDetail', fieldId }) => {
    const [showWeather, setShowWeather] = useState(false);
    const handleShowWeather = () => {
        setShowWeather(!showWeather);
    };

    const { width, height } = useWindowSize();

    if (view === 'weatherPhone')
        return (
            <Box sx={{ justifyContent: 'center', width: '100%' }}>
                <NewWeather
                    fieldId={fieldId}
                    sx={{
                        height: '300px',
                        background: 'white',
                    }}
                />
            </Box>
        );

    return (
        <Fragment>
            {showWeather ? (
                <div className={styles.containerIconWeather}>
                    <Icon
                        type='weather'
                        size='sm'
                        container='circle'
                        className={
                            settings.app.theme === 'expertobayer' ? styles.iconWeatherExpertoBayer : styles.iconWeather
                        }
                        onClick={handleShowWeather}
                    />
                </div>
            ) : (
                <div>
                    <Box
                        sx={[
                            {
                                position: 'absolute',
                                top: 10,
                                left: 30,
                                zIndex: 1101,
                                background: 'white',
                                width: 450,
                                overflow: 'scroll',
                                borderRadius: 4,
                            },

                            width && {
                                width: width - 615,
                            },
                            width &&
                                width > 1060 && {
                                    width: 450,
                                },
                        ]}
                    >
                        <Box sx={{ width: 30, height: 30, position: 'absolute', top: 7, right: 1 }}>
                            <Icon
                                type='close'
                                size='xs'
                                container='circle'
                                className={styles.iconClose}
                                onClick={handleShowWeather}
                            />
                        </Box>
                        <Box sx={{ height: '100%' }}>
                            <NewWeather fieldId={fieldId} sx={{ maxHeight: '600px', mr: '-2px' }} minHeight='580px' />
                        </Box>
                    </Box>
                </div>
            )}
        </Fragment>
    );
};

export default WeatherComponent;
